import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@y42/core/icon';
import { DataTestImportTypeCellRendererComponent } from './data-test-import-type-cell-renderer.component';

@NgModule({
  declarations: [DataTestImportTypeCellRendererComponent],
  imports: [CommonModule, IconModule],
})
export class DataTestImportTypeCellRendererModule {}
